export default "__VITE_ASSET__BPO7Q2gu__"